/**
 * The MUI theme, derived from `tokens.ts`.
 *
 * Replaces the former `src/material-ui.theme.ts`. Every value here is
 * intentionally identical to that file's output so introducing the token layer
 * is visually inert — the token values were chosen to match what the app
 * already renders.
 *
 * `MuiButton.borderRadius` is now RADIUS.md (10px), which is the value the app
 * actually rendered: the global `button { border-radius: 10px }` rule used to
 * win on specificity (0,1,0 beats 0,0,1), so MUI Buttons showed square only
 * where a `.x.MuiButton-root` patch did not already force 10px. Both the global
 * rule and the nine redundant patches are gone.
 *
 * Two items deliberately left alone, each a separate visual decision:
 *   - `height`/`minHeight: 36px` is still pinned here. No SCSS patch overrides
 *     it, so removing it would let padding drive height on every MUI Button.
 *   - `shape.borderRadius` is unset (MUI defaults to 4). Setting it would move
 *     every Paper, Card and Dialog.
 */
import { createTheme } from '@mui/material';
import { COLOR, FONT_FAMILY, FONT_SIZE, RADIUS } from './tokens';

export const DEFAULT_THEME = createTheme({
  palette: {
    text: { primary: COLOR.ink },
    primary: { main: COLOR.ink },
    secondary: { main: COLOR.legacyTeal },
    error: { main: COLOR.danger },
    success: { main: COLOR.brand },
    info: { main: COLOR.info },
  },
  typography: {
    allVariants: {
      fontFamily: FONT_FAMILY,
      fontSize: '16px',
      letterSpacing: '0.0225rem',
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: RADIUS.md,
          fontSize: FONT_SIZE.sm,
          letterSpacing: '0.05rem',
          minHeight: '36px',
          height: '36px',
          textTransform: 'none',
        },
      },
    },
  },
});
